module.exports = __webpack_public_path__ + "static/media/zigloi3.c0b23321.jpg";